export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  root: "nav-root",
  logo: "nav-logo",
  linkHome: "nav-link-home",
  linkServices: "nav-link-services",
  linkGallery: "nav-link-gallery",
  linkContact: "nav-link-contact",
  quoteBtn: "nav-quote-btn",
  mobileToggle: "nav-mobile-toggle",
  mobileMenu: "nav-mobile-menu",
};

export const HERO = {
  root: "hero-root",
  headline: "hero-headline",
  quoteCta: "hero-quote-cta",
  bookCta: "hero-book-cta",
};

export const SERVICES = {
  root: "services-root",
  card: (slug) => `service-card-${slug}`,
};

export const GALLERY = {
  root: "gallery-root",
  thumb: (i) => `gallery-thumb-${i}`,
  lightbox: "gallery-lightbox",
  lightboxClose: "gallery-lightbox-close",
};

export const CONTACT = {
  root: "contact-root",
  quoteForm: "quote-form",
  quoteName: "quote-name",
  quoteEmail: "quote-email",
  quotePhone: "quote-phone",
  quoteService: "quote-service",
  quotePropertyType: "quote-property-type",
  quoteAddress: "quote-address",
  quoteMessage: "quote-message",
  quoteSubmit: "quote-submit",
  bookForm: "book-form",
  bookName: "book-name",
  bookEmail: "book-email",
  bookPhone: "book-phone",
  bookDate: "book-date",
  bookTime: "book-time",
  bookService: "book-service",
  bookNotes: "book-notes",
  bookSubmit: "book-submit",
  tabQuote: "contact-tab-quote",
  tabBook: "contact-tab-book",
};

export const FOOTER = {
  root: "footer-root",
};
